import ReactOnRails from 'react-on-rails/client';
import HomeRevised from '../../bundles/HomeRevised/components/HomeRevised.client.jsx';

ReactOnRails.register({HomeRevised});